function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M13.82.5c.453 0 .847.167 1.18.5.333.333.5.727.5 1.18v11.64c0 .453-.167.847-.5 1.18-.333.333-.727.5-1.18.5H2.18c-.467 0-.863-.167-1.19-.5a1.63 1.63 0 0 1-.49-1.18V10.5h1.68v3.32h11.64V2.18H2.18V5.5H.5V2.18c0-.453.163-.847.49-1.18.327-.333.723-.5 1.19-.5h11.64zM6.4 11l2.14-2.18H.5V7.18h8.04L6.4 5l1.18-1.18L11.76 8l-4.18 4.18L6.4 11z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/icon-logout.527b702a.svg";
export { SvgComponent as ReactComponent };